/**
 * Capabilities tabs for Cyber Security service pages.
 */
export const CYBER_SECURITY_CAPABILITIES_EN = [
  {
    id: 'threat-hunting',
    label: 'Threat hunting',
    paragraphs: [
      'We proactively identify and mitigate potential threats before they impact your systems. Our approach goes beyond reactive security by continuously monitoring and analyzing suspicious activity.',
      'This allows us to detect vulnerabilities early, reduce risk exposure, and maintain a strong, resilient security posture across your infrastructure.',
    ],
  },
  {
    id: 'vulnerability-management',
    label: 'Vulnerability management',
    paragraphs: [
      'We assess, prioritize, and support the remediation of vulnerabilities across applications, infrastructure, and cloud environments.',
      'By combining technical analysis with business context, we help teams focus on the most critical risks and continuously strengthen their security defenses.',
    ],
  },
  {
    id: 'iam',
    label: 'IAM',
    paragraphs: [
      'We design and implement Identity and Access Management solutions that ensure the right users have the right level of access at all times.',
      'From authentication flows to role-based permissions, we help reduce security risks while maintaining usability and operational efficiency.',
    ],
  },
  {
    id: 'dora-nis2-consulting',
    label: 'DORA & NIS2 Consulting',
    paragraphs: [
      'We support organizations in preparing for and aligning with DORA and NIS2 regulatory requirements through practical, security-focused guidance.',
      'Our approach integrates compliance into your existing processes, helping you meet requirements while strengthening your overall security framework.',
    ],
  },
]

export const CYBER_SECURITY_CAPABILITIES_PT = [
  {
    id: 'threat-hunting',
    label: 'Threat hunting',
    paragraphs: [
      'Identificamos e mitigamos proativamente potenciais ameaças antes que impactem os seus sistemas. A nossa abordagem vai além da segurança reativa, com monitorização contínua e análise de atividade suspeita.',
      'Isto permite detetar vulnerabilidades cedo, reduzir exposição ao risco e manter uma postura de segurança forte e resiliente em toda a infraestrutura.',
    ],
  },
  {
    id: 'vulnerability-management',
    label: 'Gestão de vulnerabilidades',
    paragraphs: [
      'Avaliamos, priorizamos e apoiamos a correção de vulnerabilidades em aplicações, infraestrutura e ambientes cloud.',
      'Ao combinar análise técnica com contexto de negócio, ajudamos as equipas a focar-se nos riscos mais críticos e a reforçar continuamente as suas defesas de segurança.',
    ],
  },
  {
    id: 'iam',
    label: 'IAM',
    paragraphs: [
      'Desenhamos e implementamos soluções de Identity and Access Management que garantem que os utilizadores certos têm o nível de acesso certo em cada momento.',
      'De fluxos de autenticação a permissões baseadas em funções, ajudamos a reduzir riscos de segurança mantendo usabilidade e eficiência operacional.',
    ],
  },
  {
    id: 'dora-nis2-consulting',
    label: 'Consultoria DORA & NIS2',
    paragraphs: [
      'Apoiamos organizações na preparação e alinhamento com os requisitos DORA e NIS2 através de orientação prática e focada em segurança.',
      'A nossa abordagem integra conformidade nos processos existentes, ajudando a cumprir requisitos enquanto reforça o framework global de segurança.',
    ],
  },
]
